import style from "./style.module.scss";
import footer from "../../img/footer-background.png";

const Footer = () => {

	return (
		<div className={style.footer}>
			<img src={footer} alt=""/>
		</div>
	);
};

export default Footer;
